export default __webpack_public_path__ + "static/media/pageLoader.f0c8a64d.gif";